import ColorRadiiService from './ColorRadiiService';

export default class NoteService {
      _colorService = new ColorRadiiService();
     _max            = 0;
     _min            = 0;
     _formattedNotes   = [];

     constructor(noteCombo) {
         if(noteCombo !== null) {
             this._NOTE_ARRAY = noteCombo;
             this.setFormattedNotes();
         }
     }

      setYRange(notes) {
        let max = 0;
        let min = 100;
        for(let i=0; i<notes.length; i++) {
            let tempY = notes[i].f + 0.5;
            if(tempY > max) {
                max = tempY;
            }
            if(tempY < min) {
                min = tempY;
            }
        }
        this._max = max;
        this._min = min;
      }

      getYMax() {
          return this._max;
      }

      getYMin() {
          return this._min;
      }

      findNote(f, s) {
          for(var i=0; i<this._NOTE_ARRAY.length; i++) {
              let currentNote = this._NOTE_ARRAY[i]
              if(currentNote.f === f && currentNote.s===s) {
                  return true;
              }
          }
          return false;
      }

      getGoodAndBadNotes() {
          let allNotes = this._NOTE_ARRAY.slice();
          let minFret = Math.min(...this._NOTE_ARRAY.map(item => item.f));
          let maxFret = Math.max(...this._NOTE_ARRAY.map(item => item.f));
          for(var f=minFret; f<=maxFret; f++) {
              for(var s=1; s<=6; s++) {
                    if(!this.findNote(f,s)) {
                        allNotes.push({n:'x', s:s, f:f})
                    }
              }
          }

          return allNotes;
      }

    getAllNotes() {
          let allNotes = this.getGoodAndBadNotes();
          for(var i=0; i<allNotes.length; i++) {
              let note = allNotes[i].n;

                  if(note==='x' ) {
                      allNotes[i]['color'] = this._colorService.black()
                  }
                  else{
                      if( allNotes[i].color !==this._colorService.black()) {
                          allNotes[i]['color'] = this._colorService.goodColor()
                      }
                      else {
                          allNotes[i]['color'] = this._colorService.black()
                      }
                  }
           }

          return allNotes;
      }

      setFormattedNotes() {
        let allNotes = this.getAllNotes();
        this.setYRange(allNotes);
        let min = this._min;
        let max = this._max;
          const SMALL_RADIUS = 1

        for (let i= 0; i < allNotes.length; i++) {
            let noteData = allNotes[i]
            const  NUM_STRINGS= 6;
            let x = NUM_STRINGS-noteData.s+1  ;
            let y = min + max - (noteData.f + 0.5);
            let c = allNotes[i]['color']

            let r = SMALL_RADIUS
            let h = this._colorService.goodColor()

            if(noteData.n === 'x') {
              //  r = SMALL_RADIUS
                h = this._colorService.badColor()
            }
            this._formattedNotes.push({x,y,c,r,h});
        }
    }
     getGraphFormattedNotes() {
          return this._formattedNotes;
     }

     getRadii(hiddenColors) {
         let radii = []
         for(var i=0; i<hiddenColors.length; i++) {
             if(hiddenColors[i]==='white') {
                 let badColor =  this._colorService.getBadRadius()
                 radii.push(badColor)
             }
             else {
                 let goodColor =  this._colorService.getGoodRadius()
                 radii.push(goodColor)
             }

         }
         return radii
     }
     getNotePropertyData(featureName) {
         let customArray = []
         for(var i=0; i<this._formattedNotes.length; i++) {
             customArray.push(this._formattedNotes[i][featureName])
         }
         return customArray
     }
  }
